import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import Label from './common/label';
import { channelOutletMapping, CONSTANT } from '../../utils/constant';
import request from '../../utils/request';
import { outletIdStoreCodeMapping } from '../constant';

const Outlet = ({ labels, errors, touched, role, setFieldValue }) => {
  const {
    KEYS: {
      ROLES: { SALES_SUPPORT }
    }
  } = CONSTANT;
  const [channelsList, setChannelsList] = useState([]);

  const getFieldLabel = label =>
    role === SALES_SUPPORT ? label.replace('*', '') : label;

  const getChannel = outletValue => {
    let result = '';
    Object.keys(channelOutletMapping).forEach(channel => {
      if (_.get(channelOutletMapping, channel, []).includes(outletValue))
        result = channelsList.filter(item => item.label === channel);
    });
    return result;
  };

  const getMappedStoreCode = outletId => {
    return outletIdStoreCodeMapping[outletId] || null;
  };

  useEffect(() => {
    request.get('/channels').then(({ data: { channels } }) => {
      const updatedChannelList = channels.map(({ name, description }) => {
        return { id: name, label: description };
      });
      setChannelsList(updatedChannelList);
    });
  }, []);

  return (
    <>
      <Label labelName={getFieldLabel(labels.OUTLET)} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.outlet && touched.outlet ? 'error' : ''
        }`}
      >
        <Field
          type="text"
          placeholder={getFieldLabel(labels.OUTLET)}
          className="select-style"
          name="outlet"
          onChange={e => {
            const { value } = e.target;
            setFieldValue('outlet', value);
            const mappedChannel = getChannel(value);
            if (mappedChannel) setFieldValue('channel', mappedChannel);
            const mappedStoreCode = getMappedStoreCode(value);
            if (mappedStoreCode) setFieldValue('storeCode', mappedStoreCode);
          }}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.outlet}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

Outlet.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default Outlet;
